import { SelectOption } from "@/src/common/components/Select/index"
import InputErrors from "@/src/sb/components/Input/InputErrors"
import classNames from "classnames"
import Select, { Props as ReactSelectProps } from "react-select"
import { GroupBase } from "react-select/dist/declarations/src/types"

const SimpleSelect = <
  Option = SelectOption,
  isMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  removeInputBorder,
  errors,
  ...restProps
}: { removeInputBorder?: boolean; errors?: string[] } & ReactSelectProps<
  Option,
  isMulti,
  Group
>) => {
  const showError = Boolean(errors?.length)

  return (
    <>
      <Select<Option, isMulti, Group>
        unstyled
        menuPlacement={"auto"}
        blurInputOnSelect={true}
        menuShouldScrollIntoView={true}
        classNames={{
          container: () =>
            "font-jakarta text-stears_black !min-w-max dark:text-stears_white dark:bg-[#1F2937] min-h-[38px] border-[0.5px] border-[#4B5563] rounded-0 text-sm text-[#E5E7EB]",
          menu: () =>
            "bg-white shadow-sm -mx-[0.5px] !w-[448px] !min-w-max dark:bg-[#1F2937] dark:border-[#4B5563] border-[0.5px] text-xs py-2",
          control: () =>
            classNames({
              "focus-within:border-stears_black hover:border-stears_black px-3.5":
                !removeInputBorder,
              "border-stears_danger text-stears_danger": showError
            }),
          option: () =>
            "px-2.5 py-2 hover:bg-gray-50 dark:text-stears_white dark:hover:bg-[#4B5563] dark:hover:text-stears_white",
          placeholder: () => "text-gray-300 dark:text-[#E5E7EB] text-xs",
          indicatorsContainer: () => "text-gray-500 dark:text-[#E5E7EB] px-2.5",
          noOptionsMessage: () => "px-4 py-2.5 text-blue-400",
          loadingMessage: () => "px-4 py-2.5 text-gray-500",
          ...restProps.classNames
        }}
        {...restProps}
      />
      {showError ? (
        <InputErrors errors={errors ?? []} name={restProps.name as string} />
      ) : null}
    </>
  )
}

export default SimpleSelect
